import { jsxs, jsx } from "react/jsx-runtime";
import { Box, ToggleCard, Paragraph } from "@zillow/constellation";
const Tile = ({
  href,
  Icon,
  IconOutline,
  onClick,
  selected = false,
  target = "_blank",
  title
}) => {
  const RenderedIcon = selected ? Icon : IconOutline;
  return /* @__PURE__ */ jsxs(Box, { as: ToggleCard, padding: {
    default: "sm",
    md: "lg"
  }, onClick: () => {
    onClick == null ? void 0 : onClick();
  }, pressed: selected, cardType: "secondary", sx: {
    position: "relative"
  }, children: [
    href ? /* @__PURE__ */ jsx(Box, { as: "a", href, target, sx: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0
    } }) : null,
    /* @__PURE__ */ jsxs(Box, { sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ jsx(RenderedIcon, { size: "lg", marginBottom: "xs" }),
      /* @__PURE__ */ jsx(Paragraph, { fontType: selected ? {
        default: "finePrintHeading",
        md: "bodyHeading"
      } : {
        default: "finePrint",
        md: "body"
      }, textAlign: "center", children: title })
    ] })
  ] });
};
export {
  Tile as default
};
